module.exports = __webpack_public_path__ + "static/media/matriz3.77178289.svg";